<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_ix"></a><img alt="Image" src="images/chap.jpg"/></p>
<h2 class="h2b"><strong>Table of Contents</strong></h2>
<p class="toc-entry"><span href="#/xhtml/frontmatter01" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc-entry"><a href="#/xhtml/frontmatter02">Introduction:</a></p>
<p class="toc-entry-1"><a href="#/xhtml/frontmatter02">Can You Learn to be a SuperStar?</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter01">Key 1:</a></p>
<p class="toc-entry-1"><a href="#/xhtml/chapter01">Your Sales History: You Have to Know Where You’ve Been to Know How to Get to Where You Want to Go</a></p>
<p class="toc-entry"><span href="#/xhtml/chapter02" title="Link target outside of Sample">Key 2:</span></p>
<p class="toc-entry-1"><span href="#/xhtml/chapter02" title="Link target outside of Sample">Knowing Your Strengths and Weaknesses</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter03" title="Link target outside of Sample">Key 3:</span></p>
<p class="toc-entry-1"><span href="#/xhtml/chapter03" title="Link target outside of Sample">Committing to Your Career: What are You Willing to Invest?</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Key 4:</span></p>
<p class="toc-entry-1"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Finding Your Place in the Marketplace</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter05" title="Link target outside of Sample">Key 5:</span></p>
<p class="toc-entry-1"><span href="#/xhtml/chapter05" title="Link target outside of Sample">Aligning Your Strengths to Your Marketing Methods</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Key 6:</span></p>
<p class="toc-entry-1"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Making Realistic Sales and Income Projections and Goals</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter07" title="Link target outside of Sample">Key 7:</span></p>
<p class="toc-entry-1"><span href="#/xhtml/chapter07" title="Link target outside of Sample">Finding Your Sales Process</span></p>
<p class="toc-entry"><a id="page_x"></a><span href="#/xhtml/chapter08" title="Link target outside of Sample">Key 8:</span></p>
<p class="toc-entry-1"><span href="#/xhtml/chapter08" title="Link target outside of Sample">Developing a Communication Campaign that Advances Your Cause</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter09" title="Link target outside of Sample">Key 9:</span></p>
<p class="toc-entry-1"><span href="#/xhtml/chapter09" title="Link target outside of Sample">Developing the Skills You Need: Finding the Right Training</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter10" title="Link target outside of Sample">Key 10:</span></p>
<p class="toc-entry-1"><span href="#/xhtml/chapter10" title="Link target outside of Sample">Turning Plans into Reality: Turning Giant Steps into Small Steps</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter11" title="Link target outside of Sample">Key 11:</span></p>
<p class="toc-entry-1"><span href="#/xhtml/chapter11" title="Link target outside of Sample">Accountability: Finding Your Coach or Mentor</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter12" title="Link target outside of Sample">Key 12:</span></p>
<p class="toc-entry-1"><span href="#/xhtml/chapter12" title="Link target outside of Sample">The Sales SuperStar Mindset</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter13" title="Link target outside of Sample">Key 13:</span></p>
<p class="toc-entry-1"><span href="#/xhtml/chapter13" title="Link target outside of Sample">For Sales Managers, Companies, and Event Planners</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter01" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?59e9aff4